module.exports = __webpack_public_path__ + "img/partner20.a89ef9a6.svg";